"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Application from foundation/Application
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const WriteOrderIcon = createSVGIcon(
  <>
    <rect
      x=".5"
      y="3.167"
      width="14.446"
      height="15"
      rx=".5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.379 6.833h6.757M3.379 9.25H7.24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.379 11.542H7.24"
      stroke="currentColor"
      strokeMiterlimit="16"
      strokeLinecap="round"
    />
    <path
      d="m10.122 12.483 6.87-7.624 1.993 1.808-6.6 7.674-3.375 1.925z"
      fill="#fff"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </>,
  "Write Order",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    titleAccess: "Write Order",
    className: legacyIconCls(),
  }
);
